"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { WebsocketService } from "@/utils/webSocketService";
import Mked from "./Mked.vue";
import NotUseDialog from "./NotUseDialog.vue";
import _ from "lodash";
import { Debounce } from "vue-debounce-decorator";
import Question from "@/components/Question.vue";
import EditSessionDialog from "./components/EditSessionDialog.vue";
const deepSeek = require("@/assets/img/ai/deepseek.png");
const qwen = require("@/assets/img/ai/qwen.png");
const newchat = require("@/assets/img/ai/newchat.png");
const chatgpt = require("@/assets/img/ai/chatgpt.png");
const aiImage = require("@/assets/img/ai/createImage.png");
const iconImage = require("@/assets/img/ai/AIIcon.png");
const chat = require("@/assets/img/ai/chat.png");
import { MAIN_WEBSOCKET } from "@/configuration/websocketskey";
let AI = class extends Vue {
  constructor() {
    super(...arguments);
    this.webSocketService = new WebsocketService(MAIN_WEBSOCKET);
    this.msg = "";
    this.welcomeText = "";
    this.sessionList = [];
    this.sessionId = "";
    this.accountId = "";
    this.orgId = "";
    this.userId = "";
    this.hasSession = false;
    this.sendLoading = false;
    this.writing = false;
    this.thinking = false;
    this.chatDataList = [];
    this.isCollapse = false;
    this.isCheckIn = false;
    this.initLoading = true;
    this.team_pointer = 0;
    this.deepseek = deepSeek;
    this.chatgpt = chatgpt;
    this.qwen = qwen;
    this.newchat = newchat;
    this.aiImage = aiImage;
    this.iconImage = iconImage;
    this.chat = chat;
    this.AIModelList = [
      // {
      //   key: "DeepSeek-R1",
      //   name: "DeepSeek R1",
      //   tip: this.$t("ai_manager.deepseek_huawei"),
      //   img: deepSeek,
      // },
      // {
      //   key: "DeepSeek-V3",
      //   name: "DeepSeek V3",
      //   tip: this.$t("ai_manager.deepseek_huawei"),
      //   img: deepSeek,
      // },
      // {
      //   key: "deepseek-r1",
      //   name: "DeepSeek R1",
      //   tip: this.$t("main.deepseek_ali"),
      //   img: deepSeek,
      // },
      // {
      //   key: "deepseek-v3",
      //   name: "DeepSeek V3",
      //   tip: this.$t("main.deepseek_ali"),
      //   img: deepSeek,
      // },
      // {
      //   key: "deepseek-ai/DeepSeek-R1",
      //   name: "DeepSeek R1",
      //   tip: this.$t("main.deepseek_flow"),
      //   img: deepSeek,
      // },
      // {
      //   key: "deepseek-ai/DeepSeek-V3",
      //   name: "DeepSeek V3",
      //   tip: this.$t("main.deepseek_flow"),
      //   img: deepSeek,
      // },
      // {
      //   key: "qwen-max",
      //   name: this.$t("ai_manager.qwen_max"),
      //   img: qwen,
      // },
      // {
      //   key: "qwen-plus",
      //   name: this.$t("ai_manager.qwen_plus"),
      //   img: qwen,
      // },
      // {
      //   key: "qwen-turbo",
      //   name: this.$t("ai_manager.qwen_trubo"),
      //   img: qwen,
      // },
    ];
    this.AIModel = "";
    this.AIImageList = [
      {
        key: "DeepSeek-R1",
        name: "DeepSeek-R1",
        img: deepSeek
      },
      {
        key: "DeepSeek-V3",
        name: "DeepSeek V3",
        img: deepSeek
      },
      {
        key: "ChatGPT-4o",
        name: "ChatGPT-4o",
        img: chatgpt
      }
    ];
    this.selectModel = "chat";
    this.sessionMenuList = [];
    this.appToken = "";
    this.appSession = null;
  }
  // resultLang = "zh-CN";
  // langList = [
  // ]
  created() {
    return __async(this, null, function* () {
      this.webSocketService.run();
      this.webSocketService.on(
        "event:pageEvent.logout.success",
        () => __async(this, null, function* () {
          this.appToken = "";
          this.$router.push("/auth_login");
        })
      );
      this.webSocketService.on(
        "event:change.team.success",
        () => __async(this, null, function* () {
          this.appToken = "";
          yield this.changeAppToken();
          yield this.getAIModels();
          yield this.showWelCome();
          yield this.getPermission();
        })
      );
    });
  }
  mounted() {
    return __async(this, null, function* () {
      document.querySelector("html").style.minWidth = "0px";
      document.querySelector("html").style.backgroundColor = "#ffffff";
      document.body.style.minWidth = "0px";
      document.body.style.backgroundColor = "#ffffff";
      document.querySelector("#app").style.minWidth = "0px";
      document.querySelector("#app").style.backgroundColor = "#ffffff";
      yield this.changeAppToken();
      yield this.getAIModels();
      window.addEventListener("resize", this.handleResize);
      yield this.showWelCome();
      yield this.getPermission();
    });
  }
  changeAppToken() {
    return __async(this, null, function* () {
      try {
        const token_response = yield API.get(
          `api://base.local/storages/preference/aitoken`
        );
        this.appToken = token_response.data.value.token;
        const session_response = yield API.get(`https://gateway.kuajingvs.com/chat/v1/session`, {
          headers: {
            "Authorization": this.appToken
          }
        });
        this.appSession = session_response.data;
      } catch (error) {
        console.log(error);
        const tokeResponse = yield API.get(
          `api://base.local/storages/preference/token`
        );
        const _token = tokeResponse.data.value.token;
        const response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/auth`,
          {
            headers: {
              Authorization: _token
            }
          }
        );
        this.appToken = response.data.token;
        const session_response = yield API.get(`https://gateway.kuajingvs.com/chat/v1/session`, {
          headers: {
            "Authorization": this.appToken
          }
        });
        this.appSession = session_response.data;
        yield API.put(`api://base.local/storages/preference/aitoken`, {
          token: response.data.token
        });
      }
    });
  }
  getAIModels() {
    return __async(this, null, function* () {
      try {
        const model_response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/products/AI`,
          {
            headers: {
              Authorization: this.appToken
            }
          }
        );
        let providerList = model_response.data.providers;
        let modelList = model_response.data.models;
        for (let model of modelList) {
          let provider = _.find(providerList, { id: model.parentId });
          if (provider && provider !== void 0) {
            let modelItem = {
              key: model.code,
              name: model.name,
              tip: `(${provider.name}${provider.useCustomAPIKey ? this.$t("ai_manager.custom") : ""})`,
              model: model.model,
              type: provider.code
            };
            if (model.name.toLowerCase().indexOf("deepseek") !== -1) {
              modelItem.img = deepSeek;
            }
            if (model.name.toLowerCase().indexOf("gpt") !== -1) {
              modelItem.img = chatgpt;
            }
            this.AIModelList.push(modelItem);
          }
        }
        this.AIModel = this.AIModelList[0].key;
      } catch (error) {
        console.log(error);
      }
    });
  }
  // async checkVersion() {
  //   try {
  //     let version = await API.get(`api://base.local/update/version`);
  //     let _version = version.data.version;
  //     if (_version !== "6.9.2") {
  //       this.$router.push("/");
  //     }
  //   } catch (error) {
  //     this.$router.push("/");
  //   }
  // }
  handleToApp(command) {
    if (command === "pocket") {
      window.open("https://chat.kuajingvs.com/quota", "_blank");
    }
    if (command === "team") {
      window.open("https://chat.kuajingvs.com/team", "_blank");
    }
    if (command === "setting") {
      window.open("https://chat.kuajingvs.com/settings", "_blank");
    }
    if (command === "feedback") {
      window.open("https://app.kuajingvs.com/feedback", "_blank");
    }
  }
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
  handleResize() {
    if (this.isCollapse && window.innerWidth > 680) {
      this.isCollapse = false;
    }
    if (!this.isCollapse && window.innerWidth < 680) {
      this.isCollapse = true;
    }
  }
  closeAside() {
    this.isCollapse = true;
  }
  checkSideBar() {
    if (window.innerWidth < 680) {
      return true;
    }
    return false;
  }
  showWelCome() {
    return __async(this, null, function* () {
      if (this.writing) {
        return;
      }
      this.writing = true;
      this.welcomeText = "";
      let text = this.$t("ai_manager.welcome");
      for (const char of text) {
        this.welcomeText += char;
        yield new Promise((resolve) => setTimeout(resolve, 50));
      }
      this.writing = false;
    });
  }
  toSession(id) {
    return __async(this, null, function* () {
      this.sessionId = id;
      this.hasSession = true;
      yield this.getSessionDetail();
    });
  }
  toNewSession() {
    return __async(this, null, function* () {
      this.hasSession = false;
      this.sessionId = "add";
      this.chatDataList = [];
      this.selectModel = "chat";
      yield this.showWelCome();
    });
  }
  toNewImageSession() {
    return __async(this, null, function* () {
      this.hasSession = false;
      this.sessionId = "add-image";
      this.chatDataList = [];
      this.selectModel = "image";
      yield this.showWelCome();
    });
  }
  handleSelectSession(command) {
    return __async(this, null, function* () {
      if (command.method === "delete") {
        yield this.deleteSession(command.id);
      }
      if (command.method === "editname") {
        yield this.editSessionName(command.data);
      }
    });
  }
  editSessionName(row) {
    return __async(this, null, function* () {
      this._editSessionDialog.open(row, this.appToken);
    });
  }
  getPermission() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth.pro/v1/chat-check-vd`);
        if (response.data.hasAvailableVd) {
          yield this.getPoints();
          yield this.getSessionList();
        } else {
          this._notUseDialog.open();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.initLoading = false;
      }
    });
  }
  // 签到
  // @Debounce(800)
  // async checkPoint() {
  //   try {
  //     if (this.isCheckIn) {
  //       return;
  //     }
  //     const response = await API.post(`api://base.auth.pro/v1/chat-sign-in`);
  //     this.isCheckIn = true;
  //     await this.getPoints();
  //   } catch (error: any) {
  //     if (error.hasOwnProperty("response")) {
  //       this.$message.error(error.response.data.errors.datas[0].message);
  //     }
  //   }
  // }
  // 判断是否已签到
  // async checkIn() {
  //   try {
  //     const response = await API.get(`api://base.auth.pro/v1/chat-sign-in`);
  //     this.isCheckIn = response.data;
  //     return response.data;
  //   } catch (error: any) {
  //     console.log(error);
  //     return false;
  //   }
  // }
  // 获取团队点数
  getPoints() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/session`,
          {
            headers: {
              Authorization: this.appToken
            }
          }
        );
        this.team_pointer = response.data.balance;
        this.userId = response.data.userId;
        this.accountId = response.data.accountId;
        this.orgId = response.data.orgId;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getSessionList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/chat-sessions`,
          {
            params: {
              size: 20,
              type: "TEXT"
            },
            headers: {
              Authorization: this.appToken
            }
          }
        );
        this.sessionList = response.data.datas;
        if (this.sessionList.length > 0) {
          if (localStorage.getItem("sessionId")) {
            this.sessionId = localStorage.getItem("sessionId");
            let sessionItem = _.find(this.sessionList, { id: this.sessionId });
            if (sessionItem) {
              this.hasSession = true;
              yield this.getSessionDetail();
            }
          } else {
            this.sessionId = this.sessionList[0].id;
            this.hasSession = true;
            yield this.getSessionDetail();
          }
        } else {
          this.hasSession = false;
          this.sessionId = "add";
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  createSession() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(
          `https://gateway.kuajingvs.com/chat/v1/chat-sessions`,
          {
            type: "TEXT"
          },
          {
            headers: {
              Authorization: this.appToken
            }
          }
        );
        this.sessionId = response.data.sessionId;
        localStorage.setItem("sessionId", this.sessionId);
      } catch (error) {
      }
    });
  }
  getSessionDetail() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/chat-sessions/${this.sessionId}`,
          {
            headers: {
              Authorization: this.appToken
            }
          }
        );
        this.chatDataList = response.data.datas;
        setTimeout(() => {
          if (this._chatScroll) {
            this._chatScroll.scrollTo({
              top: this._chatScroll.scrollHeight,
              behavior: "smooth"
            });
          }
        }, 1);
        if (this.chatDataList.length === 0) {
          this.hasSession = false;
          yield this.showWelCome();
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  toFeedBack() {
    window.open("https://app.kuajingvs.com/feedback", "_blank");
  }
  handleMenuSelect(key) {
    return __async(this, null, function* () {
      if (key !== "add" && key !== "add-image") {
        localStorage.setItem("sessionId", key);
      }
    });
  }
  sendMsg(event) {
    return __async(this, null, function* () {
      if (this.sendLoading) {
        return;
      }
      if (event.keyCode == 13 && event.shiftKey) {
        event.preventDefault();
        this.msg = this.msg + "\n";
      } else if (event.keyCode == 13) {
        event.preventDefault();
        if (!/\S/.test(this.msg)) {
          return;
        }
        let message = this.msg;
        this.msg = "";
        let messageElement = { role: "user", content: message };
        this.chatDataList.push(messageElement);
        let needGetList = false;
        if (this.hasSession === false && (this.sessionId === "add" || this.sessionId === "add-image")) {
          this.hasSession = true;
          yield this.createSession();
          needGetList = true;
        }
        this.thinking = true;
        this.sendLoading = true;
        yield this.realSendMsg(message, needGetList);
      }
    });
  }
  clickToSend() {
    return __async(this, null, function* () {
      if (!/\S/.test(this.msg)) {
        return;
      }
      let message = this.msg;
      this.msg = "";
      let messageElement = { role: "user", content: message };
      this.chatDataList.push(messageElement);
      let needGetList = false;
      if (this.hasSession === false && (this.sessionId === "add" || this.sessionId === "add-image")) {
        this.hasSession = true;
        yield this.createSession();
        needGetList = true;
      }
      this.thinking = true;
      this.sendLoading = true;
      yield this.realSendMsg(message, needGetList);
    });
  }
  realSendMsg(message, needGetList) {
    return __async(this, null, function* () {
      var _a;
      try {
        if (!/\S/.test(message)) {
          return;
        }
        if (this.team_pointer <= 0) {
          this.$message.error(this.$t("ai_manager.no_point"));
          return;
        }
        let modelItem = _.find(this.AIModelList, { key: this.AIModel });
        let sendData = {
          input: message.trim(),
          model: modelItem.model,
          code: modelItem.key,
          type: modelItem.type,
          sessionId: this.sessionId,
          orgId: this.orgId,
          accountId: this.accountId,
          userId: this.userId,
          isEnableContext: true
        };
        this.thinking = true;
        this.sendLoading = true;
        this.hasSession = true;
        setTimeout(() => {
          this._chatScroll.scrollTop = this._chatScroll.scrollHeight;
        }, 500);
        const response = yield fetch(
          `https://openai.kuajingvs.com/v1/chat-sessions-send`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: this.appToken || "",
              "X-LANG": "zh-CN",
              "Accept-Language": "zh-CN",
              "X-Client-Ver": "6.9.2",
              "x-app-id": "6f8db093",
              "x-app-secret": "78dc83b754da6ae6",
              platform: "pc",
              Accept: "text/event-stream"
            },
            body: JSON.stringify(sendData)
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const reader = (_a = response.body) == null ? void 0 : _a.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let mked = { role: "assistant", content: "" };
        this.chatDataList.push(mked);
        while (true) {
          this.thinking = false;
          const { done, value } = yield reader.read();
          if (done) {
            yield this.getPoints();
            if (needGetList) {
              try {
                setTimeout(() => __async(this, null, function* () {
                  const response2 = yield API.get(
                    `https://gateway.kuajingvs.com/chat/v1/chat-sessions`,
                    {
                      params: {
                        size: 20,
                        type: "TEXT"
                      },
                      headers: {
                        Authorization: this.appToken
                      }
                    }
                  );
                  this.sessionList = response2.data.datas;
                }), 5e3);
              } catch (error) {
                console.log(error);
              }
            }
            break;
          }
          buffer += decoder.decode(value);
          while (buffer.includes("\n")) {
            const newlineIndex = buffer.indexOf("\n");
            const event = buffer.slice(0, newlineIndex).trim();
            buffer = buffer.slice(newlineIndex + 1);
            if (event.startsWith("data:")) {
              const data = event.slice(5).trim();
              try {
                const jsonData = JSON.parse(data);
                let text = jsonData.content;
                if (text !== "[DONE]") {
                  if (text === "```\n") {
                    text = "\n```\n";
                  }
                  yield this.typerWriter(text, mked);
                }
              } catch (error) {
              }
            }
          }
        }
        this.sendLoading = false;
        this.hasSession = true;
      } catch (error) {
        this.sendLoading = false;
        this.thinking = false;
        let mked = {
          role: "assistant",
          content: "\u5F88\u62B1\u6B49, \u670D\u52A1\u6682\u65F6\u65E0\u6CD5\u4F7F\u7528, \u8BF7\u7A0D\u540E\u518D\u8BD5\u3002"
        };
        this.chatDataList.push(mked);
      }
    });
  }
  // 删除会话
  deleteSession(id) {
    return __async(this, null, function* () {
      try {
        if (localStorage.getItem("sessionId")) {
          let sid = localStorage.getItem("sessionId");
          if (sid === id) {
            localStorage.removeItem("sessionId");
          }
        }
        if (this.sessionId === id) {
          this.sessionId = "add";
          this.hasSession = false;
        }
        yield API.delete(
          `https://gateway.kuajingvs.com/chat/v1/chat-sessions/${id}`,
          {
            headers: {
              Authorization: this.appToken
            }
          }
        );
        let response = yield API.get(
          `https://gateway.kuajingvs.com/chat/v1/chat-sessions`,
          {
            params: {
              size: 20,
              type: "TEXT"
            },
            headers: {
              Authorization: this.appToken
            }
          }
        );
        this.sessionList = response.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 打字机输出效果
  typerWriter(text, outputElement) {
    return __async(this, null, function* () {
      for (const char of text) {
        outputElement.content += char;
        this._chatScroll.scrollTop = this._chatScroll.scrollHeight;
        yield new Promise((resolve) => setTimeout(resolve, 10));
      }
    });
  }
};
__decorateClass([
  Ref("notUseDialog")
], AI.prototype, "_notUseDialog", 2);
__decorateClass([
  Ref("chatScroll")
], AI.prototype, "_chatScroll", 2);
__decorateClass([
  Ref("editSessionDialog")
], AI.prototype, "_editSessionDialog", 2);
__decorateClass([
  Debounce(600)
], AI.prototype, "realSendMsg", 1);
AI = __decorateClass([
  Component({
    components: {
      Mked,
      NotUseDialog,
      Question,
      EditSessionDialog
    }
  })
], AI);
export {
  AI as default
};
